<template>
  <div style="margin:7%">
    <scc-user-details
      ref="refUserDetails"
      :userProfileId="userId"
      v-if="isRightUser"
      :is-user-profile="true"
    />
    <div v-else>
      Please contact SCC Admin, to confirm you permissions. The user Id does not
      match.
    </div>
  </div>
</template>
<script>
import Vue from 'vue';

import { ButtonPlugin } from '@syncfusion/ej2-vue-buttons';
import { TextBoxPlugin } from '@syncfusion/ej2-vue-inputs';
import { mapGetters } from 'vuex';
import SccUserDetails from '../components/scc-user-details.vue';

Vue.use(ButtonPlugin);
Vue.use(TextBoxPlugin);

export default {
  name: 'SccUserProfile',
  components: {
    SccUserDetails,
  },
  computed: {
    ...mapGetters({
      loggedUser: 'loggedUser',
    }),
    userId() {
      return this.$route.params.id;
    },
    isRightUser() {
      return this.userId === this.loggedUser?.id;
    },
  },
};
</script>
